import { render, staticRenderFns } from "./IconSelect.vue?vue&type=template&id=961e3230&scoped=true"
import script from "./IconSelect.vue?vue&type=script&lang=js"
export * from "./IconSelect.vue?vue&type=script&lang=js"
import style0 from "./IconSelect.vue?vue&type=style&index=0&id=961e3230&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961e3230",
  null
  
)

export default component.exports